import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  ROLE,
  USER_ROLE,
  BACKGROUND,
  ROLE_LAB,
  SUPER_ADNIM,
  ROLEDOCTOR,
  ROLE_RECEPTION,
  USER_INFO,
} from "../Constant";
import { useState, useEffect } from "react";
import "./Heade.css";
import CustomSwitch from "./CustomeSwitch";
import { ROLE_ADMIN } from "../report/visitConstant/ApiConstant";

const Header = () => {
  const counter = useSelector((state) => state.counter);
  const isLogged = useSelector((state) => state.isLogged);
  const navigate = useNavigate();
  const location = useLocation();

  // State variables
  const [showEdit, setShowEdit] = useState(false);
  const [isLab, setIsLab] = useState(false);
  const [userRoles, setUserRoles] = useState(null);
  const [hoveredLink, setHoveredLink] = useState(null);
  const [scrollingText, setScrollingText] = useState([
    "Appointment",
    "Dr. Booking",
    "Lab Test",
  ]);
  const [activeIndex, setActiveIndex] = useState(0);

  const userRole = localStorage.getItem(USER_ROLE);

 

        const user = JSON.parse(localStorage.getItem(USER_INFO));

  // Check user roles and set appropriate states
  useEffect(() => {
    try {
      setUserRoles(userRole);

      if (
        userRole?.includes(ROLE) ||
        userRole?.includes(SUPER_ADNIM) ||
        userRole?.includes(ROLEDOCTOR) ||
        userRole?.includes(ROLE_LAB) ||
        userRole?.includes(ROLE_RECEPTION)
      ) {
        setShowEdit(true);
      } else if (
        userRole?.includes(ROLE_LAB) ||
        userRole?.includes(SUPER_ADNIM)
      ) {
        setIsLab(true);
      } else {
        setShowEdit(false);
      }
    } catch (e) {
      console.error("Error setting user roles:", e);
    }
  }, [isLogged, userRole]);

  // Set up scrolling text effect
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % scrollingText.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [scrollingText.length]);

  // Style functions
  const isActive = (path, currentPath) => path === currentPath;

  const commonStyle = {
    textDecoration: "none",
    color: "#fff",
    paddingBottom: "1px",
    marginBottom: "0",
    transition: "all 0.1s ease",
  };

  const getUnderlineStyle = (path, currentPath, isHovered) => ({
    ...commonStyle,
    borderBottom:
      isActive(path, currentPath) || isHovered ? "3px solid #cedff6" : "none",
    color: isActive(path, currentPath) || isHovered ? "#cedff6" : "#fff",
    marginLeft: "10px",
    marginRight: "10px",
  });

  // Render login/logout menu
  const RenderMenu = () => {
    if (userRole) {
      return (
        <ul className="navbar-nav me-auto mb-lg-0 d-none d-md-block">
          <li className="nav-item pb-3">
            <Link
              className="nav-link text-primary"
              replace
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              onClick={() => navigate("/logout")}
            >
              <FontAwesomeIcon
                icon="fa-solid fa-right-from-bracket"
                className="me-3 text-primary"
                style={{ width: "16px", height: "16px" }}
              />
              Logout
            </Link>
          </li>
        </ul>
      );
    } else {
      return (
        <ul className="navbar-nav me-auto mb-lg-0">
          <li className="nav-item pb-3">
            <Link
              className="nav-link text-primary"
              replace
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              onClick={() => navigate("/login")}
            >
              <FontAwesomeIcon
                icon="fa-solid fa-user"
                className="text-primary me-3"
                style={{ width: "16px", height: "16px" }}
              />
              Login
            </Link>
          </li>
        </ul>
      );
    }
  };

  return (
    <nav className="navbar navbar-dark border-bottom fixed-top bg-light pt-3">
      <div className="container">
        {/* Back button */}
        <Link
          className="navbar-brand text-center d-flex justify-content-center align-items-center"
          style={{ width: location.pathname === "/" ? "" : "28px" }}
          onClick={() => navigate(-1)}
        >
          {location.pathname === "/" ? (
            ""
          ) : (
            <FontAwesomeIcon
              icon="fa-solid fa-arrow-left"
              className="text-center text-primary"
            />
          )}
        </Link>

        {/* Mobile Logo */}
        <div className="col overflow-hidden d-block d-lg-none">
          <Link className="navbar-brand" to="/">
            <img src="./../favicon.ico" className="img" alt="appLogo" />
            <small className="text-primary fw-bold">Health</small>
          </Link>
        </div>

        {/* Desktop Logo */}
        <div className="d-none d-lg-block overflow-auto">
          <Link className="navbar-brand" to="/">
            <img src="./../favicon.ico" className="img" alt="appLogo"style={{maxHeight:30}} />
            <span> </span>
            <small className="text-primary fw-bold">Health</small>
          </Link>
        </div>

        {/* Search Bar (currently commented out) */}
        <div
          className="d-none d-md-flex mx-auto align-items-center position-sticky"
          style={{ width: "42%" }}
        >
          {/* Search functionality can be re-enabled here if needed */}
        </div>

        {/* Login Button */}
        <div className="px-0 d-none d-sm-block">
          {userRole ? null : (
            <button
              className="btn text-primary"
              onClick={() => navigate("/login")}
            >
              Login
            </button>
          )}
        </div>

        {/* Custom Switch Component */}
        {/* {showEdit && <CustomSwitch />} */}

        {/* User Menu Toggle Button */}
        <div className="">
          <FontAwesomeIcon
            icon="fa-regular fa-user"
            type="button"
            className="navbar-toggler text-primary border border-primary rounded-2"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasDarkNavbar"
            aria-controls="offcanvasDarkNavbar"
          />
        </div>

        {/* Off-canvas Sidebar */}
        <div
          className="offcanvas offcanvas-end bg-light"
          tabIndex={-1}
          id="offcanvasDarkNavbar"
          aria-labelledby="offcanvasDarkNavbarLabel"
        >
          {/* Sidebar Header */}
          <div className="offcanvas-header">
            <h5
              className="offcanvas-title text-primary"
              id="offcanvasDarkNavbarLabel"
            >
              <img src="./../favicon.ico" className="img me-2" alt="appLogo" />
              Health
            </h5>
            <button
              type="button"
              className="btn-close btn-close-primary"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            />
          </div>

          {/* Sidebar Body */}
          <div className="offcanvas-bodyn" style={{ overflowY: "scroll" }}>
            <ul className="navbar-nav justify-content-end flex-grow-1 px-4">
              {/* Profile Link (only for logged-in users) */}
              {userRole && (
                <li className="nav-item text-truncate">
                  <Link
                    className="nav-link text-primary"
                    replace
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                    onClick={() => navigate("/profile")}
                  >
                    <FontAwesomeIcon
                      icon="fa-solid fa-user"
                      className="me-3 text-primary"
                      style={{ width: "16px", height: "16px" }}
                    />
                    Profile
                  </Link>
                </li>
              )}

              {/* All Tokens Link */}
              <li className="nav-item text-truncate">
                <Link
                  className="nav-link text-primary"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                  replace
                  onClick={() => navigate("/tokenbooking")}
                >
                  <FontAwesomeIcon
                    icon="fa-solid fa-list-ol"
                    className="me-3 text-primary"
                    style={{ width: "16px", height: "16px" }}
                  />
                  All Tokens
                </Link>
              </li>
              <li className="nav-item text-truncate">
                <Link
                  className="nav-link text-primary"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                  replace
                  onClick={() => navigate("/tokenPage")}
                >
                  <FontAwesomeIcon
                    icon="fa-solid fa-database"
                    className="me-3 text-primary"
                    style={{ width: "16px", height: "16px" }}
                  />
                  Token report
                </Link>
              </li>

              {/* Admin Options */}
              {user?.role.includes(ROLE_ADMIN) && (
                <li className="nav-item text-truncate">
                  <Link
                    className="nav-link text-primary"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                    replace
                    onClick={() => navigate("/createToken")}
                  >
                    <FontAwesomeIcon
                      icon="fa-solid fa-list-ol"
                      flip
                      className="me-3 text-primary"
                      style={{ width: "16px", height: "16px" }}
                    />
                    Create Token
                  </Link>

                  {/* <Link
                    className="nav-link text-primary"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                    replace
                    onClick={() => navigate("/drsignup")}
                  >
                    <FontAwesomeIcon
                      icon="fa-solid fa-user-doctor"
                      className="me-3 text-primary"
                      style={{ width: "16px", height: "16px" }}
                    />
                    Create new doctor
                  </Link> */}
                  <Link
                    className="nav-link text-primary"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                    replace
                    onClick={() => navigate("/mastermedicine")}
                  >
                    <FontAwesomeIcon
                      icon="fas fa-file-medical"
                      className="me-3 text-primary"
                      style={{ width: "16px", height: "16px" }}
                    />
                    Master
                  </Link>
                  {/* <Link
                    className="nav-link text-primary"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                    replace
                    onClick={() => navigate("/advertisementForm")}
                  >
                    <FontAwesomeIcon
                      icon="fas fa-ad"
                      className="me-3 text-primary"
                      style={{ width: "16px", height: "16px" }}
                    />
                    Advertisement Form
                  </Link> */}
                </li>
              )}

              {/* Super Admin Options */}
              {userRoles?.includes(SUPER_ADNIM) && (
                <>
                  <li className="nav-item text-truncate">
                    <Link
                      className="nav-link text-primary"
                      data-bs-dismiss="offcanvas"
                      aria-label="Close"
                      replace
                      onClick={() => {
                        sessionStorage.setItem(
                          "savedActiveIdx",
                          JSON.stringify(0)
                        );
                        navigate("/Employee");
                      }}
                    >
                      <FontAwesomeIcon
                        icon="fa-solid fa-users"
                        className="me-3 text-primary"
                        style={{ width: "17px", height: "17px" }}
                      />
                      Staff Management
                    </Link>
                  </li>

                  {/* <li className="nav-item text-truncate">
                    <Link
                      className="nav-link text-primary"
                      data-bs-dismiss="offcanvas"
                      aria-label="Close"
                      replace
                      onClick={() => {
                    
                        navigate("/addHospital");
                      }}
                    >
                      <FontAwesomeIcon
                        icon="fa-solid fa-users"
                        className="me-3 text-primary"
                        style={{ width: "17px", height: "17px" }}
                      />
                     Create new hospital
                    </Link>
                  </li> */}
                </>
              )}

              {/* Lab Options */}
              {isLab && (
                <li className="nav-item text-truncate">
                  <Link
                    className="nav-link text-primary"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                    replace
                    onClick={() => navigate("/tokenPage")}
                  >
                    <FontAwesomeIcon
                      icon="fa-solid fa-database"
                      className="me-3 text-primary"
                      style={{ width: "16px", height: "16px" }}
                    />
                    Lab report
                  </Link>
                </li>
              )}

              {/* Login/Logout Menu */}
              <li className="nav-item">
                <RenderMenu />
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Navigation for Desktop */}
        {userRole && (
          <div className="col-12 d-none d-md-block text-center fw-semibold text-primary mt-3 ms-4">
            <Link
              to="/"
              style={getUnderlineStyle(
                "/",
                location.pathname,
                hoveredLink === "/"
              )}
              onMouseEnter={() => setHoveredLink("/")}
              onMouseLeave={() => setHoveredLink(null)}
            >
              <small className="mx-2 text-primary">Home</small>
            </Link>
            {showEdit && (
              <Link
                to="/createToken"
                style={getUnderlineStyle(
                  "/createToken",
                  location.pathname,
                  hoveredLink === "/createToken"
                )}
                onMouseEnter={() => setHoveredLink("/createToken")}
                onMouseLeave={() => setHoveredLink(null)}
              >
                <small className="mx-2 text-primary">Create Token</small>
              </Link>
            )}
            <Link
              to="/tokenbooking"
              style={getUnderlineStyle(
                "/tokenbooking",
                location.pathname,
                hoveredLink === "/tokenbooking"
              )}
              onMouseEnter={() => setHoveredLink("/tokenbooking")}
              onMouseLeave={() => setHoveredLink(null)}
            >
              <small className="mx-2 text-primary">All Tokens</small>
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Header;
